import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ReactDatePicker from "react-datepicker";
import { Button } from "./Button";
import { View } from "./View";
/**
 * Web platform date picking interface component offering API compatibility
 * with `react-native-modal-datetime-picker`.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-130}
 */ export function WebDatePickerInner(props) {
    return /*#__PURE__*/ _jsxs(View, {
        style: {
            alignItems: 'center'
        },
        testID: "DateTimePicker",
        children: [
            /*#__PURE__*/ _jsx(ReactDatePicker, {
                fixedHeight: true,
                inline: true,
                onChange: props.onDateChange,
                selected: props.date,
                showTimeSelect: props.mode === 'datetime' || props.mode === 'time',
                showTimeSelectOnly: props.mode === 'time',
                timeIntervals: props.minuteInterval,
                showMonthDropdown: true,
                showYearDropdown: true,
                dropdownMode: "select",
                minDate: props.mode === 'time' ? undefined : props.minimumDate,
                maxDate: props.mode === 'time' ? undefined : props.maximumDate,
                minTime: props.mode === 'time' ? props.minimumDate : undefined,
                maxTime: props.mode === 'time' ? props.maximumDate : undefined
            }),
            global.e2e ? /*#__PURE__*/ _jsx(Button, {
                // Not used in V2 e2e tests
                text: "Confirm",
                onPress: function() {
                    return props.onDateChange(new Date());
                }
            }) : null
        ]
    });
}
